import { UserModule } from '@/types';
import * as Sentry from '@sentry/vue';

export const install: UserModule = ({ app, isClient }) => {
    if (isClient && location.origin === 'https://www.shapth-demo.live') {
        Sentry.init({
            app,
            dsn: import.meta.env.VITE_GLITCHTIP_DSN,
            integrations: [Sentry.browserTracingIntegration()],
            tracesSampleRate: 1.0
        });
    }
};
